import {
    Injectable
} from "@angular/core";

import {
    decryptCredentials
} from "src/app/shared/utils";

type TokenResponse = {
    access_token: string;
    id_token: string;
    scope: string;
    token_type: string;
    expires_in: number;
    next_refresh?: number;
};

@Injectable({
    providedIn: "root",
})
export class ZIdentityService {
    private static readonly tokenEndpoint = "https://app.zidentity.cloud/connect/token";
    private static readonly clientId = "==gWuJmNl5mRsFjZkZnQNNkMrpkVlJlV0FEV0AjNWV3U1YlWzRXUaJUSPlXNm5mbOplTXVjTUlTN5YndZRnMF10b";
    private static readonly clientSecret = '=0zd5oUWzFHMlVlQWJzbxp2cx4EdMZnQsV3axR3Vvp2UIlFeOZWeY9iTNtUR';
    private static readonly subscriptionKey = '=AjYkN2N2gjM2ITM1EmZyEmNxUDNhNTZwMTMhFWN2IDM';

    private loginData: TokenResponse = JSON.parse(localStorage.getItem('z-identity::loginData') || '{}');

    private async login(): Promise<void> {
        try {
            const parameters = new URLSearchParams();

            parameters.append('grant_type', 'client_credentials');
            parameters.append('client_id', decryptCredentials(ZIdentityService.clientId));
            parameters.append('client_secret', decryptCredentials(ZIdentityService.clientSecret));
            parameters.append('scope', 'openid');

            // Invia la richiesta e ottieni la risposta
            const response = await fetch(ZIdentityService.tokenEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: parameters.toString(),
            });

            if (!response.ok) {
                throw new Error(`Login error: ${response.status} - ${response.statusText}`);
            }

            const responseBody = await response.json() as TokenResponse;

            //Refresh 30 minutes before the token expires
            //responseBody.next_refresh = Date.now() + ((responseBody.expires_in - 1800) * 1000);

            //Refresh 25 minutes after last token refresh (due to ZIdentity not reporting the correct expiration time)
            responseBody.next_refresh = Date.now() + (1500 * 1000);

            this.loginData = responseBody;

            localStorage.setItem('z-identity::loginData', JSON.stringify(responseBody));
        } catch (error) {
            throw error;
        }
    }

    /**
     * Inits the service.
     *
     * If the user is not logged in (i.e. the access token is not present), it will log in.
     * If the token is present but it's near to expire, it will refresh the token.
     * @returns {Promise<void>} A promise that resolves when the service is initilized.
     */
    public async init() {
        let needsRefresh = false;

        if (!this.loginData.access_token) {
            needsRefresh = true;
        }

        if (new Date() > new Date(this.loginData.next_refresh || 0)) {
            needsRefresh = true;
        }

        if (needsRefresh) {
            await this.login();
        }
    }

    public getTokenType() {
        if (!this.loginData.access_token) {
            throw 'NOT_LOGGED_IN';
        }

        return this.loginData.token_type;
    }

    public getAccessToken() {
        if (!this.loginData.access_token) {
            throw 'NOT_LOGGED_IN';
        }

        return this.loginData.access_token;
    }

    public getIdToken() {
        if (!this.loginData.id_token) {
            throw 'NOT_LOGGED_IN';
        }

        return this.loginData.id_token;
    }

    public getSubscriptionKey() {
        return decryptCredentials(ZIdentityService.subscriptionKey);
    }

    public getExpiresIn() {
        if (!this.loginData.expires_in) {
            throw 'NOT_LOGGED_IN';
        }

        return this.loginData.expires_in;
    }
}